(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["banner"] && !Shopify.designMode) return;
  try {
    gsap.registerPlugin(ScrollTrigger);

const videos = document.querySelectorAll(".banner__video");

videos.forEach((video) => {
  ScrollTrigger.create({
    trigger: video.closest(".banner"),
    start: "top bottom",    // wanneer banner in beeld komt
    end: "bottom top",      // zolang banner in beeld is
    // markers: true,
    onEnter: () => video.play(),       // afspelen bij naar beneden scrollen
    onEnterBack: () => video.play(),   // afspelen bij naar boven scrollen
    onLeave: () => video.pause(),      // pauzeren als uit beeld
    onLeaveBack: () => video.pause()   // pauzeren als uit beeld omhoog
  });

});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bar-chart"] && !Shopify.designMode) return;
  try {
    gsap.registerPlugin(ScrollTrigger);

const heights = ["30%", "50%", "75%", "100%"];

const bar_wrap = document.querySelectorAll(".bar__wrap");

heights.forEach((height, i) => {
  const block = document.querySelector(`.block-${i + 1}`);
  const banner = block.closest(".banner");

  // ScrollTrigger voor binnenkomst (zowel omlaag als omhoog)
  ScrollTrigger.create({
    trigger: bar_wrap,
    start: "top bottom", // wanneer banner in beeld komt
    end: "bottom top",   // actief zolang banner (deels) in beeld is
    duration: 2,
    // markers: true,
    onEnter: () => gsap.to(block, { height, duration: 1 }),
    onEnterBack: () => gsap.to(block, { height, duration: 1 }),
    onLeave: () => gsap.to(block, { height: "0%", duration: 0.5 }),
    onLeaveBack: () => gsap.to(block, { height: "0%", duration: 0.5 })
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["graph-number-animation"] && !Shopify.designMode) return;
  try {
    /**
 * Graph Number Animation - GSAP animatie voor oplopende nummers
 * Gebruikt ScrollTrigger om animatie te starten wanneer element in beeld komt
 */

class GraphNumberAnimation {
  constructor() {
    this.init();
  }

  init() {
    // Wacht tot DOM en GSAP geladen zijn
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      console.warn('GSAP of ScrollTrigger niet geladen - nummer animatie uitgeschakeld');
      return;
    }

    // Registreer ScrollTrigger plugin
    gsap.registerPlugin(ScrollTrigger);
    
    // Start animaties voor alle graph number blocks
    this.setupAnimations();
  }

  setupAnimations() {
    // Vind alle graph containers
    const graphContainers = document.querySelectorAll('[id^="graph-"]');
    
    graphContainers.forEach(container => {
      this.animateNumbers(container);
    });
  }

  animateNumbers(container) {
    const animatedNumbers = container.querySelectorAll('.animated__number');
    
    if (!animatedNumbers.length) return;

    // Maak timeline voor deze container
    const tl = gsap.timeline({
      paused: true
    });

    animatedNumbers.forEach((numberElement, index) => {
      const targetValue = parseInt(numberElement.dataset.value) || 0;
      const isPercentage = numberElement.textContent.includes('%');
      const hasPlus = numberElement.textContent.includes('+');
      
      // Start waarde op 0
      let currentValue = 0;
      numberElement.textContent = isPercentage ? '0%' : (hasPlus ? '0+' : '0');

      // Animeer het nummer met een delay per element
      tl.to({ value: 0 }, {
        value: targetValue,
        duration: 2,
        ease: "power2.out",
        onUpdate: function() {
          currentValue = Math.round(this.targets()[0].value);
          if (isPercentage) {
            numberElement.textContent = currentValue + '%';
          } else if (hasPlus) {
            numberElement.textContent = currentValue + '+';
          } else {
            numberElement.textContent = currentValue;
          }
        }
      }, index * 0.2); // 0.2 seconden delay tussen elk nummer
    });

    // ScrollTrigger configuratie
    ScrollTrigger.create({
      trigger: container,
      start: "top 99%", // Start animatie wanneer top van element 80% in beeld is
      end: "bottom 20%",
      onEnter: () => {
        tl.restart(); // Herstart animatie
      },
      // Optioneel: reset wanneer element uit beeld gaat
      onLeave: () => {
        // Uncomment volgende regel om nummers te resetten bij verlaten beeld
        // this.resetNumbers(container);
      },
      onEnterBack: () => {
        tl.restart(); // Herstart bij terug scrollen
      }
    });
  }

  resetNumbers(container) {
    const animatedNumbers = container.querySelectorAll('.animated__number');
    
    animatedNumbers.forEach(numberElement => {
      const isPercentage = numberElement.textContent.includes('%');
      const hasPlus = numberElement.textContent.includes('+');
      
      if (isPercentage) {
        numberElement.textContent = '0%';
      } else if (hasPlus) {
        numberElement.textContent = '0+';
      } else {
        numberElement.textContent = '0';
      }
    });
  }
}

// Initialiseer de animatie wanneer de pagina geladen is
document.addEventListener('DOMContentLoaded', () => {
  new GraphNumberAnimation();
});

// Voor Shopify theme editor live preview
document.addEventListener('shopify:section:load', () => {
  new GraphNumberAnimation();
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["logo-change-animation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const logoImages = document.querySelectorAll('.animated-logo-img');
    
    if (logoImages.length <= 1) return; // Stop als er maar 1 logo of minder is
    
    let currentIndex = 0;
    
    function showNextLogo() {
      // Verberg huidige logo
      logoImages[currentIndex].classList.remove('active');
      
      // Ga naar volgende logo (terug naar 0 als we aan het einde zijn)
      currentIndex = (currentIndex + 1) % logoImages.length;
      
      // Toon volgende logo
      logoImages[currentIndex].classList.add('active');
    }
    
    // Start de animatie elke 5 seconden
    setInterval(showNextLogo, 3000);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["quote-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quote-slider')) {
    class QuoteSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.quote-slide'));
        if (this.slides.length === 0) return;

        this.classList.add('is-initialized');
        this.setActive(0);

        this.intervalMs = (parseInt(this.dataset.interval, 10) || 5) * 1000;
        this.start();

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());

        if (window.Shopify && window.Shopify.designMode) {
          // In de theme editor: toon de geselecteerde quote en pauzeer.
          document.addEventListener('shopify:block:select', (event) => {
            const index = this.slides.indexOf(event.target);
            if (index >= 0) {
              this.stop();
              this.setActive(index);
            }
          });
          document.addEventListener('shopify:block:deselect', (event) => {
            if (this.slides.indexOf(event.target) >= 0) this.start();
          });
        }
      }

      disconnectedCallback() {
        this.stop();
      }

      setActive(index) {
        this.index = index;
        this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      }

      start() {
        this.stop();
        if (this.slides.length < 2) return;
        this.timer = setInterval(() => {
          this.setActive((this.index + 1) % this.slides.length);
        }, this.intervalMs);
      }

      stop() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }
    }

    customElements.define('quote-slider', QuoteSlider);
  }
  } catch(e) { console.error(e); }
})();

})();
